/**
 * Splits a filename into name and extension parts
 * @param fileName - The filename to split
 * @returns Object containing name and extension
 */
export const splitFileNameExtension = (fileName: string) => {
  const lastDotIndex = fileName.lastIndexOf('.');
  if (lastDotIndex === -1) {
    return { name: fileName, extension: '' };
  }
  return {
    name: fileName.substring(0, lastDotIndex),
    extension: fileName.substring(lastDotIndex + 1),
  };
};
